export const handleExit = (exitOption: string | undefined): void => {
  if (exitOption) {
    location.href = exitOption;
  } else {
    window.history.back();
  }
};
